import Loadable from 'react/components/loadable';

const PushNotificationImageModal = Loadable({
  loader: () => import('../../pages/messages/push_notification_image_modal'),
  type: 'modal',
});

angular.module('gym').value('PushNotificationImageModal', PushNotificationImageModal);
